export default "/images/fingerprint-verification-on-mobile-phone.png?abb78d9dfd8c73839cc171daecf95f85";